import ApiService from "@/utils/api.service";
export default {
    getList(context) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("accounts")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    get(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("accounts/" + params)
                .then(({ data }) => {
                    context.commit("setAccount", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    clean(context) {
        context.commit("clear");
    },
    getOrders(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("accounts/" + params + "/orders")
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    }
}